// src/context/MyContext.js
import { createContext, Component } from "react";
import { DEFAULT_USER_DATA } from "../utils/Constants/Constants";

// Create Context
export const MyContext = createContext();

// Create Provider Component
export class MyProvider extends Component {
    state = {
        mainMenuMessage: "Main Menu",
        userData: DEFAULT_USER_DATA,
    }

    // update the mainMenuMessage
    updateMainMenuMessage = (newMessage) => {
        this.setState({ mainMenuMessage: newMessage });
    }

    // update userData in context
    updateUserData = (data) => {
        this.setState({ userData: { ...DEFAULT_USER_DATA, ...data } })
    }

    render() {
        return (
            <MyContext.Provider
                value={{
                    mainMenuMessage: this.state.mainMenuMessage,
                    updateMainMenuMessage: this.updateMainMenuMessage, // Pass updater function
                    userData: this.state.userData,
                    updateUserData: this.updateUserData,
                    cometdInstance: this.props.cometdInstance
                }}
            >
                {this.props.children}
            </MyContext.Provider>
        );
    }
}
